import EmailLogin from "../Login/EmailLogin";
import ModalGeneric from "./ModalGeneric";

// modal to show that user needs to install metamask
export default function ModalLogin({callback}) {
	return (
        <ModalGeneric title={"Log In / Sign Up"} callback={callback}>
            <div className="mt-4">
                <EmailLogin />
            </div>
        </ModalGeneric>
	);
}
